/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ReactNode, useCallback } from "react";
import { AuthProvider } from "react-oidc-context";
import { AuthConfig } from "config/auth";
import authorizedCall from "features/common/utils/authorizedCall";
import { buildAuditRequestBody } from "features/user/utils/buildAuditRequestBody";
import { UserActionControllerService } from "openapi";

export interface OIDCAuthProviderProps {
  children: ReactNode;
}

export const OIDCAuthProvider = ({ children }: OIDCAuthProviderProps) => {
  const onSignIn = useCallback(
    () =>
      authorizedCall(UserActionControllerService.addUserAction, {
        requestBody: buildAuditRequestBody({
          cdOperation: "login",
          description: "login",
        }),
      }),
    []
  );

  return (
    <AuthConfig>
      {(authProviderProps) => (
        <AuthProvider {...authProviderProps} onSigninCallback={onSignIn}>
          {children}
        </AuthProvider>
      )}
    </AuthConfig>
  );
};
